module.exports = __webpack_public_path__ + "img/14.058f8786.png";